module.exports = __webpack_public_path__ + "static/img/web_spot_service_icon.8bb7a64d.png";